// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:09:27

export default {
  "id": "gloves-grow-rush",
  "slug": "gloves-grow-rush",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e7f0caf8cdb04b31be6431f5710f1dfa-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e7f0caf8cdb04b31be6431f5710f1dfa/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Gloves Grow Rush",
      "description": "“Gloves Grow Rush” is a 3D arcade game where you control stickman boxers in a vertical running challenge. Collect boxing gloves, battle weaker opponents, and take on the final boss at each level. If you encounter a stronger boxer, evade rather than fight to survive. Beware: a direct punch means game over! Claim gems to upgrade your starting level and attack power (ATK). The shop offers 6 unique boxing gloves, but they don’t grant extra ATK or levels. Best of luck!",
      "instructions": "Hold and swipe = move left and right",
      "genres": [
        "Agility",
        "Casual"
      ],
      "tags": [
        "3d",
        "arcade",
        "attack",
        "running",
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "手套生长狂潮",
      "description": "“手套生长狂潮”是一款3D街机游戏，你将操控棒人拳击手在垂直跑酷挑战中。收集拳击手套，与较弱对手战斗，并在每个级别挑战最终Boss。若遇到更强的拳击手，应躲避而非战斗以求生存。小心：直接被击中即游戏结束！收集宝石以提升你的起始等级和攻击力（ATK）。商店提供6种独特的拳击手套，但它们不提供额外的ATK或等级。祝你好运！",
      "instructions": "长按并滑动 = 向左右移动",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "3D",
        "街机",
        "攻击",
        "奔跑",
        "棍人"
      ]
    },
    "zh-TW": {
      "title": "手套成長竄升",
      "description": "“Gloves Grow Rush”是一款3D街機遊戲，您在遊戲中控制著條形拳擊手在垂直跑酷挑戰中。收集拳擊手套，與較弱的對手戰鬥，並在每個關卡挑戰最終頭目。如果遇到更強的拳擊手，請躲避而非戰鬥以維持生命。注意：直接被打擊即意味著遊戲結束！收集寶石以升級您的起始等級和攻擊力（ATK）。商店提供6種獨特的手套，但它們不會增加ATK或等級。祝您好运！",
      "instructions": "按住並滑動 = 左右移動",
      "genres": [
        "敏捷度",
        "輕鬆模式"
      ],
      "tags": [
        "3D",
        "街機",
        "攻擊",
        "奔跑",
        "殘影"
      ]
    },
    "zh-HK": {
      "title": "手套生長急速",
      "description": "「格蘿格路斯」是一款3D街機遊戲，遊戲中你將操控著擠壓人形拳手進行垂直跑酷挑戰。收集拳套，戰勝較弱的對手，並在每個關卡挑戰最終頭目。若遇強大拳手，則應避免戰鬥以保命。注意：直接被打中即意味著遊戲結束！收集寶石以升級你的起始等級和攻擊力（ATK）。商店提供6種獨特拳套，但它們不會增加ATK或等級。祝你好運！",
      "instructions": "握住並滑動 = 橫向移動左右",
      "genres": [
        "敏捷度",
        "休闲"
      ],
      "tags": [
        "3D",
        "街機",
        "攻擊",
        "奔跑",
        "立體小人"
      ]
    },
    "ja": {
      "title": "グローブ・グロー・ラッシュ",
      "description": "“Gloves Grow Rush”は、垂直走行チャレンジでストックマンボクサーを操作する3Dアーケードゲームです。ボクシンググローブを集め、弱い相手と戦い、各レベルで最終ボスに挑戦します。強いボクサーに遭遇したら、生存のために戦う代わりに回避しましょう。気をつけて：直接のパンチはゲームオーバーです！宝石を収集して、スタートレベルと攻撃力（ATK）をアップグレードしてください。ショップでは6種類のユニークなボクシンググローブが用意されていますが、追加のATKやレベルはもたらしません。運気を祈ります！",
      "instructions": "ホールドしてスワイプ＝左と右に移動",
      "genres": [
        "アギリティ",
        "カジュアル"
      ],
      "tags": [
        "3D",
        "アーケード",
        "攻撃",
        "走行",
        "スティックマン"
      ]
    },
    "ko": {
      "title": "장갑 성장 스피드",
      "description": "\"글로브 그ロー 러시\"는 세대 아케이드 게임으로, 가로로 달리는 챌린지에서 스틱맨 박수들을 제어합니다. 박수를 모으고 약한 적들과 싸우고, 각 레벨마다 최종 보스를 맞서십시오. 더 강한 박수를 만났을 때는 싸우지 말고 피하세요. 주의하세요: 직접적인 패치는 게임 오버입니다! 보석을 모아 시작 레벨과 공격력(ATK)을 업그레이드하세요. 가게는 6개의 독특한 박수를 제공하지만, 추가 ATK나 레벨을 주지 않습니다. 많은 운이 있기를 바랍니다!",
      "instructions": "지우고 슬라이드 = 왼쪽과 오른쪽으로 이동",
      "genres": [
        "敏捷력",
        "일반"
      ],
      "tags": [
        "3D",
        "아케이드",
        "공격",
        "달리기",
        "스틱맨"
      ]
    },
    "fr": {
      "title": "Gants de croissance Urgence",
      "description": "“Gloves Grow Rush” est un jeu d'arcade en 3D où vous contrôlez des boxeurs stickman dans un défi de course verticale. Collectez des gants de boxe, combattez des adversaires plus faibles et affrontez le boss final à chaque niveau. Si vous rencontrez un boxeur plus fort, évitez plutôt que de combattre pour survivre. Attention : un coup direct signifie la fin de la partie ! Revendiquez des gemmes pour améliorer votre niveau de départ et votre puissance d'attaque (ATK). Le magasin offre 6 gants de boxe uniques, mais ils ne vous donnent pas d'ATK ou de niveaux supplémentaires. Bonne chance !",
      "instructions": "Maintenir et glisser = déplacer vers la gauche et la droite",
      "genres": [
        "Agilité",
        "Occasionnel"
      ],
      "tags": [
        "3D",
        "arcade",
        "attaque",
        "course",
        "stickman"
      ]
    }
  }
};
